<div class="container">
	<div class="table-wrapper">
		<table class="table">
			<thead>
				<tr>
					<!-- <th class="">
						<div class="custom-checkbox">
							<input class="orders_inputAll" type="checkbox" id="select-all">
							<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
					</th> -->
					<th (click)="sortData('order_number')" style="cursor: pointer;">
						<ng-container i18n="@@orders.order">Order</ng-container>
						<svg class="svg_sort" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.6665 10.0003L7.99984 13.3337L11.3332 10.0003M4.6665 6.00033L7.99984 2.66699L11.3332 6.00033" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
					</th>
					<th i18n="@@orders.name">Name</th>
					<th i18n="@@orders.phone">Phone</th>
					<th i18n="@@orders.date_time" style="min-width: 140px;">Date</th>
					<th style="min-width: 140px;"></th>
					<th i18n="@@orders.payment">Payment</th>
					<th i18n="@@orders.status">Status</th>
					<th i18n="@@orders.payment_status">Payment Status</th>
					<th i18n="@@orders.order_type">Order Type</th>
					<th (click)="sortData('total_amount')" style="cursor: pointer;">
						<ng-container i18n="@@orders.total">Total</ng-container>
						<svg class="svg_sort" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.6665 10.0003L7.99984 13.3337L11.3332 10.0003M4.6665 6.00033L7.99984 2.66699L11.3332 6.00033" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
					</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td></td>
					<td></td>
					<td></td>
					<td (click)="sortData('created_at')" class="position-relative" style="cursor: pointer;">
						<ng-container i18n="@@orders.creation_date">Creation Date</ng-container>
						<svg class="svg_sort" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.6665 10.0003L7.99984 13.3337L11.3332 10.0003M4.6665 6.00033L7.99984 2.66699L11.3332 6.00033" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
					</td>
					<td (click)="sortData('due_at')" class="position-relative" style="cursor: pointer;">
						<ng-container i18n="@@orders.due_date">Due Date</ng-container>
						<svg class="svg_sort" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.6665 10.0003L7.99984 13.3337L11.3332 10.0003M4.6665 6.00033L7.99984 2.66699L11.3332 6.00033" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				<tr class="orders_item order_show" *ngFor="let order of orders | paginate: paginator; let i = index"
					[attr.data-status]="order.order_status?.status">
					<!-- <td class="">
						<div class="custom-checkbox">
							<input type="checkbox" class="select-item orders_inputAll">
							<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
					</td> -->
					<td class="" (click)="onViewOrder.emit(order)"><span class="underline-secondary order_id">#{{ order.order_number }}</span></td>
					<td>{{ order.client_name }}</td>
					<td>{{ order.client_phone }}</td>
					<td>{{ order.order_date | date : 'mediumDate' }}<br>{{ order.order_date | date : 'shortTime' }}</td>
					<td>
						<span class="d-flex align-items-center justify-content-between">
							<span>{{ order.due_at | date : 'mediumDate' }}<br>{{ order.due_at | date : 'shortTime' }}</span>
							<span class="schedule-flag" (click)="orderActions('change_priority', order.uuid)">
								<svg *ngIf="order?.priority == 'high'" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M13.3587 2.48205C12.492 3.15938 11.7127 3.31271 10.9627 3.23138C10.176 3.14671 9.40133 2.80471 8.53733 2.41938L8.502 2.40338C7.67867 2.03538 6.76867 1.62871 5.81133 1.52538C4.804 1.41671 3.76467 1.64271 2.692 2.48138C2.63218 2.52816 2.5838 2.58795 2.55053 2.65622C2.51726 2.72449 2.49998 2.79944 2.5 2.87538V14C2.5 14.1327 2.55268 14.2598 2.64645 14.3536C2.74021 14.4474 2.86739 14.5 3 14.5C3.13261 14.5 3.25979 14.4474 3.35355 14.3536C3.44732 14.2598 3.5 14.1327 3.5 14V10.7094C4.29067 10.1527 5.00933 10.0274 5.704 10.1027C6.49067 10.1867 7.26533 10.5287 8.12933 10.9147L8.16467 10.93C8.988 11.2987 9.898 11.7047 10.8553 11.808C11.8627 11.9167 12.902 11.6907 13.9747 10.852C14.0345 10.8053 14.0829 10.7455 14.1161 10.6772C14.1494 10.6089 14.1667 10.534 14.1667 10.458V2.87538C14.1666 2.78171 14.1402 2.68996 14.0904 2.61057C14.0407 2.53118 13.9697 2.46735 13.8855 2.42636C13.8013 2.38536 13.7073 2.36884 13.6141 2.37869C13.521 2.38854 13.4325 2.42435 13.3587 2.48205Z" fill="#EB1414"></path>
								</svg>
								<svg *ngIf="order?.priority == 'medium'" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M13.3587 2.48205C12.492 3.15938 11.7127 3.31271 10.9627 3.23138C10.176 3.14671 9.40133 2.80471 8.53733 2.41938L8.502 2.40338C7.67867 2.03538 6.76867 1.62871 5.81133 1.52538C4.804 1.41671 3.76467 1.64271 2.692 2.48138C2.63218 2.52816 2.5838 2.58795 2.55053 2.65622C2.51726 2.72449 2.49998 2.79944 2.5 2.87538V14C2.5 14.1327 2.55268 14.2598 2.64645 14.3536C2.74021 14.4474 2.86739 14.5 3 14.5C3.13261 14.5 3.25979 14.4474 3.35355 14.3536C3.44732 14.2598 3.5 14.1327 3.5 14V10.7094C4.29067 10.1527 5.00933 10.0274 5.704 10.1027C6.49067 10.1867 7.26533 10.5287 8.12933 10.9147L8.16467 10.93C8.988 11.2987 9.898 11.7047 10.8553 11.808C11.8627 11.9167 12.902 11.6907 13.9747 10.852C14.0345 10.8053 14.0829 10.7455 14.1161 10.6772C14.1494 10.6089 14.1667 10.534 14.1667 10.458V2.87538C14.1666 2.78171 14.1402 2.68996 14.0904 2.61057C14.0407 2.53118 13.9697 2.46735 13.8855 2.42636C13.8013 2.38536 13.7073 2.36884 13.6141 2.37869C13.521 2.38854 13.4325 2.42435 13.3587 2.48205Z" fill="#FCCF0B"></path>
								</svg>
								<svg *ngIf="order?.priority == 'low'" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M13.3587 2.48205C12.492 3.15938 11.7127 3.31271 10.9627 3.23138C10.176 3.14671 9.40133 2.80471 8.53733 2.41938L8.502 2.40338C7.67867 2.03538 6.76867 1.62871 5.81133 1.52538C4.804 1.41671 3.76467 1.64271 2.692 2.48138C2.63218 2.52816 2.5838 2.58795 2.55053 2.65622C2.51726 2.72449 2.49998 2.79944 2.5 2.87538V14C2.5 14.1327 2.55268 14.2598 2.64645 14.3536C2.74021 14.4474 2.86739 14.5 3 14.5C3.13261 14.5 3.25979 14.4474 3.35355 14.3536C3.44732 14.2598 3.5 14.1327 3.5 14V10.7094C4.29067 10.1527 5.00933 10.0274 5.704 10.1027C6.49067 10.1867 7.26533 10.5287 8.12933 10.9147L8.16467 10.93C8.988 11.2987 9.898 11.7047 10.8553 11.808C11.8627 11.9167 12.902 11.6907 13.9747 10.852C14.0345 10.8053 14.0829 10.7455 14.1161 10.6772C14.1494 10.6089 14.1667 10.534 14.1667 10.458V2.87538C14.1666 2.78171 14.1402 2.68996 14.0904 2.61057C14.0407 2.53118 13.9697 2.46735 13.8855 2.42636C13.8013 2.38536 13.7073 2.36884 13.6141 2.37869C13.521 2.38854 13.4325 2.42435 13.3587 2.48205Z" fill="#BDBDBD"></path>
								</svg>
							</span>
						</span>
					</td>
					<td>{{ order.payment_method ? transStatus('via') + ' ' + (transStatus(order.payment_method) | titlecase | removeUnderscore) : '-' }}
					</td>
					<td>
						<ng-container *ngIf="(!(['oto'].includes(order.delivery_with)) && order.delivery_with != 'fixed_cost') || (['new', 'canceled', 'rejected', 'scheduled', 'declined', 'converted_to_invoice', 'converted_to_quotation'].includes(order?.current_status))">
							<div class="order_{{order?.current_status}} order_status">
								<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
									<circle cx="4" cy="4" r="4" fill="#18F121" />
								</svg>
								{{ transStatus(order.order_status?.status ? order.order_status?.status : order?.current_status) | titlecase | removeUnderscore }}
							</div>
						</ng-container>
						<ng-container *ngIf="!(['oto'].includes(order.delivery_with)) && order.delivery_with == 'fixed_cost' && !(['new', 'canceled', 'rejected', 'scheduled', 'declined', 'converted_to_invoice', 'converted_to_quotation'].includes(order?.current_status))">
							<div class="status_dropdown">
								<div class="dropdown-btn {{ (order.order_status?.status ? order.order_status?.status : order?.current_status) }}" (click)="toggleStatusMenu(i)">
									<span class="status-dot"></span>
									<span class="status-text">{{ transStatus(order.order_status?.status ? order.order_status?.status : order?.current_status) | titlecase | removeUnderscore }}</span>
									<span>
										<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M4.85742 6L8.85742 10L12.8574 6" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
									</span>
								</div>
								<div class="dropdown-menu status-dropdown-menu w-auto" id="status-dropdown-menu-{{i}}">
									<ng-container *ngIf="order.type == 'product'; else serviceDropdown;">
										<div *ngIf="order.possible_statuses.includes('pending')"
											class="dropdown-item pending"
											[ngClass]="{'tm-dropdown__item--disable' : (['pending','preparing', 'ready_to_pickup','picked_up','out_for_delivery', 'refunded', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('out_for_delivery', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.pending">Pending</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('preparing')"
											class="dropdown-item preparing"
											[ngClass]="{'tm-dropdown__item--disable' : (['preparing', 'ready_to_pickup','picked_up','canceled', 'out_for_delivery', 'refunded', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('preparing', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.preparing">Preparing</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('ready_to_pickup')"
											class="dropdown-item ready_to_pickup"
											[ngClass]="{'tm-dropdown__item--disable' : (['ready_to_pickup','out_for_delivery','picked_up','canceled', 'refunded', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('ready_to_pickup', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.ready_to_pickup">Ready to pickup</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('picked_up')"
											class="dropdown-item picked_up"
											[ngClass]="{'tm-dropdown__item--disable' : (['picked_up','out_for_delivery','canceled', 'refunded', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('picked_up', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.picked_up">Picked up</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('out_for_delivery')"
											class="dropdown-item out_for_delivery"
											[ngClass]="{'tm-dropdown__item--disable' : (['out_for_delivery', 'refunded', 'canceled', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('out_for_delivery', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.out_for_delivery">Out for delivery</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('refunded')"
											class="dropdown-item refunded"
											[ngClass]="{'tm-dropdown__item--disable' : (['refunded','canceled', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('refunded', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.refunded">Refunded</span>
										</div>
										<div *ngIf="order.possible_statuses.includes('completed')"
											class="dropdown-item completed"
											[ngClass]="{'tm-dropdown__item--disable' : (['refunded','canceled', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('completed', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.completed">Completed</span>
										</div>
										<div class="dropdown-item canceled"
											[ngClass]="{'tm-dropdown__item--disable' : (['picked_up','out_for_delivery','refunded', 'completed'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('canceled', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.canceled">Canceled</span>
										</div>
									</ng-container>
									<ng-template #serviceDropdown>
										<div class="dropdown-item pending"
											*ngIf="order.possible_statuses.includes('pending')"
											[ngClass]="{'tm-dropdown__item--disable' : (['pending','declined', 'converted_to_invoice', 'converted_to_quotation'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('pending', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.pending">Pending</span>
										</div>
										<div class="dropdown-item converted_to_quotation"
											*ngIf="order.possible_statuses.includes('converted_to_quotation')"
											[ngClass]="{'tm-dropdown__item--disable' : (['declined', 'converted_to_invoice','converted_to_quotation'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('converted_to_quotation', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.converted_to_quotation">Converted to quotation</span>
										</div>
										<div class="dropdown-item converted_to_invoice"
											*ngIf="order.possible_statuses.includes('converted_to_invoice')"
											[ngClass]="{'tm-dropdown__item--disable' : (['declined','converted_to_invoice'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('converted_to_invoice', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.converted_to_invoice">Converted to invoice</span>
										</div>
										<div class="dropdown-item declined"
											[ngClass]="{'tm-dropdown__item--disable' : (['declined', 'converted_to_invoice', 'converted_to_quotation'].includes(order.order_status?.status)) }"
											(click)="updateOrderStatus('declined', order.uuid)">
											<span class="status-dot"></span>
											<span i18n="@@orders.declined">Declined</span>
										</div>
									</ng-template>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="order.delivery_with == 'oto'">
							<div class="order_{{order?.oto_status}} order_status">
								<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
									<circle cx="4" cy="4" r="4" fill="#18F121" />
								</svg>
								{{ (order.oto_status ? order.oto_status : order?.current_status) | titlecase | removeUnderscore }}
							</div>
						</ng-container>
					</td>
					<td>
						<div class="order_pending order_status" *ngIf="order.payment_status == 'N/A'">
							<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
								<circle cx="4" cy="4" r="4" fill="#18F121" />
							</svg>
							N/A
						</div>
						<div class="order_{{order?.payment_status}} order_status" *ngIf="order.payment_status != 'N/A'">
							<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
								<circle cx="4" cy="4" r="4" fill="#18F121" />
							</svg>
							{{ transStatus((order.payment_status) | titlecase | removeUnderscore) }}
						</div>
					</td>
					<td>
						<ng-container *ngIf="order?.order_type == 'Pickup'; else delivery">
							<span i18n="@@order.pickup">Pickup</span>
						</ng-container>
						<ng-template #delivery>
							<span i18n="@@order.delivery">Delivery</span>
						</ng-template>
					</td>
					<td class="order_total">
						<span class="sar" [innerHtml]="order?.currency_symbol"></span>
						{{ order?.total_amount }}
					</td>
					<td class="text-center position-relative">
						<ng-container *ngIf="(order?.type == 'product') && (order.order_status == null || order.order_status?.status == 'new' || order.order_status?.status == ''); else noAction">
							<a href="javascript:void()" data-toggle="modal" data-target="#accept-modal" (click)="orderActions('accept', order.uuid, 'list')">
								<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
									<path d="M17.1668 5L8.00016 14.1667L3.8335 10" stroke="#11BF18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</a>
							<a href="javascript:void()" data-toggle="modal" data-target="#rejection-modal" (click)="orderActions('declined', order.uuid, 'list')">
								<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
									<path d="M15.5 5L5.5 15M5.5 5L15.5 15" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</a>
						</ng-container>
						<ng-template #noAction>
							<div class="options-menu d-none" id="options-menu-{{i}}" *ngIf="(order?.type == 'product')">
								<button class="edit-option" *ngIf="(order.payment_status != 'PAID' && !order.tax_amount) && !(['delivered','completed','delivery_ended','canceled','declined','rejected','expired'].includes(order.order_status?.status))" (click)="orderActions('cancel', order.uuid)">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M3.52876 3.52729C3.78911 3.26694 4.21122 3.26694 4.47157 3.52729L8.00016 7.05589L11.5288 3.52729C11.7891 3.26694 12.2112 3.26694 12.4716 3.52729C12.7319 3.78764 12.7319 4.20975 12.4716 4.4701L8.94297 7.9987L12.4716 11.5273C12.7319 11.7876 12.7319 12.2098 12.4716 12.4701C12.2112 12.7305 11.7891 12.7305 11.5288 12.4701L8.00016 8.94151L4.47157 12.4701C4.21122 12.7305 3.78911 12.7305 3.52876 12.4701C3.26841 12.2098 3.26841 11.7876 3.52876 11.5273L7.05735 7.9987L3.52876 4.4701C3.26841 4.20975 3.26841 3.78764 3.52876 3.52729Z" fill="#565656" />
									</svg>
									<span i18n="@@orders.cancel_order">Cancel Order</span>
								</button>
								<button class="edit-option" *ngIf="((order.payment_status == 'PAID' || order.payment_status == 'paid') && order.payment_source == 'myfatoorah' && order?.current_status != 'refunded')" (click)="checkStatusForRefund(order.uuid)">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M3.52876 3.52729C3.78911 3.26694 4.21122 3.26694 4.47157 3.52729L8.00016 7.05589L11.5288 3.52729C11.7891 3.26694 12.2112 3.26694 12.4716 3.52729C12.7319 3.78764 12.7319 4.20975 12.4716 4.4701L8.94297 7.9987L12.4716 11.5273C12.7319 11.7876 12.7319 12.2098 12.4716 12.4701C12.2112 12.7305 11.7891 12.7305 11.5288 12.4701L8.00016 8.94151L4.47157 12.4701C4.21122 12.7305 3.78911 12.7305 3.52876 12.4701C3.26841 12.2098 3.26841 11.7876 3.52876 11.5273L7.05735 7.9987L3.52876 4.4701C3.26841 4.20975 3.26841 3.78764 3.52876 3.52729Z" fill="#565656" />
									</svg>
									<span i18n="@@orders.refund">Refund</span>
								</button>
								<button class="edit-option" *ngIf="order.invoice_id" (click)="orderActions('resend_invoice', order.uuid)">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_197_12132)"> <path d="M14.6668 1.33203L7.3335 8.66536" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
											<path d="M14.6668 1.33203L10.0002 14.6654L7.3335 8.66536L1.3335 5.9987L14.6668 1.33203Z" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
										</g>
										<defs>
											<clipPath id="clip0_197_12132">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<span i18n="@@orders.resend_invoice">Resend Invoice</span>
								</button>
								<!-- <button class="delete-option" *ngIf="(['pending','new'].includes(order.current_status)) && (order.payment_status != 'PAID')" (click)="orderActions('delete', order.uuid)">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
										<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<span i18n="@@orders.delete_record">Delete Record</span>
								</button> -->
								<button class="edit-option" *ngIf="order.delivery_with == 'logistiq' && order.payment_status == 'PAID' && !order.logistiq_response" (click)="orderActions('create_logistiq', order.uuid)">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
										<path d="M14.9999 8.33326L11.6666 4.99993M2.08325 17.9166L4.90356 17.6032C5.24813 17.5649 5.42042 17.5458 5.58146 17.4937C5.72433 17.4474 5.86029 17.3821 5.98566 17.2994C6.12696 17.2062 6.24954 17.0836 6.49469 16.8385L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L3.16136 13.5052C2.91621 13.7503 2.79363 13.8729 2.70045 14.0142C2.61778 14.1396 2.55243 14.2755 2.50618 14.4184C2.45405 14.5794 2.43491 14.7517 2.39662 15.0963L2.08325 17.9166Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<span i18n="@@orders.create_logistiq">Create Logistiq Order</span>
								</button>
							</div>
							<div class="options-menu d-none" id="options-menu-{{i}}" *ngIf="(order?.type == 'service')">
								<button class="edit-option" *ngIf="order.invoice_id" (click)="orderActions('resend_invoice', order.uuid)">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_197_12132)"> <path d="M14.6668 1.33203L7.3335 8.66536" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
											<path d="M14.6668 1.33203L10.0002 14.6654L7.3335 8.66536L1.3335 5.9987L14.6668 1.33203Z" stroke="#565656" stroke-linecap="round" stroke-linejoin="round" />
										</g>
										<defs>
											<clipPath id="clip0_197_12132">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<span i18n="@@orders.resend_invoice">Resend Invoice</span>
								</button>
								<ng-container *ngIf="(order.payment_status == 'PAID' || order.payment_status == 'paid') && order.payment_source == 'myfatoorah' && order?.current_status != 'refunded'">
									<button class="edit-option"  (click)="checkStatusForRefund(order.uuid)">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M3.52876 3.52729C3.78911 3.26694 4.21122 3.26694 4.47157 3.52729L8.00016 7.05589L11.5288 3.52729C11.7891 3.26694 12.2112 3.26694 12.4716 3.52729C12.7319 3.78764 12.7319 4.20975 12.4716 4.4701L8.94297 7.9987L12.4716 11.5273C12.7319 11.7876 12.7319 12.2098 12.4716 12.4701C12.2112 12.7305 11.7891 12.7305 11.5288 12.4701L8.00016 8.94151L4.47157 12.4701C4.21122 12.7305 3.78911 12.7305 3.52876 12.4701C3.26841 12.2098 3.26841 11.7876 3.52876 11.5273L7.05735 7.9987L3.52876 4.4701C3.26841 4.20975 3.26841 3.78764 3.52876 3.52729Z" fill="#565656" />
										</svg>
										<span i18n="@@orders.refund">Refund</span>
									</button>	
								</ng-container>
							</div>
							<svg class="dots-menu" *ngIf="(order?.type == 'product') || (['pending','new'].includes(order.current_status)) || (order.payment_status != 'PAID') || !(['canceled','declined','rejected'].includes(order.order_status?.status))" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" (click)="toggleDropdownMenu(i)">
								<path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</ng-template>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<!-- paginator  -->
<ng-container *ngIf="paginator.totalItems > 0">
	<div class="pagination_wrapper">
		<div class="showing_results">
			<div class="select_wrapper">
				<ng-container i18n="@@show">Show</ng-container>
				<select class="select-link tab-links-select" id="tab-links-select" nice-select
					[(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
					<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
				</select>
				<ng-container i18n="@@items">items</ng-container>
			</div>
			<div class="results_list" *ngIf="paginator?.from || paginator?.to">
				<ng-container i18n="@@showing_from">Showing from</ng-container> {{ paginator?.from }} <ng-container
					i18n="@@to">to</ng-container> {{ paginator?.to }} <ng-container i18n="@@of">of</ng-container> {{
				paginator?.totalItems }} <ng-container i18n="@@items">items</ng-container>
			</div>
		</div>
		<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="onPageChange.emit($event)"
			aria-label="...">
			<ul class="pagination justify-content-center">
				<li class="page-item" [class.disabled]="p.isFirstPage()">
					<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
						<svg width="7.5" height="13.5">
							<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round"
								stroke-linejoin="round" stroke-width="1.5" />
						</svg>
					</a>
				</li>
				<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
					<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
						<span>{{ page.label }}</span>
					</a>
					<a *ngIf="p.getCurrent() === page.value" class="page-link">
						{{page.label}}
						<span class="sr-only">(current)</span>
					</a>
				</li>
				<li class="page-item" [class.disabled]="p.isLastPage()">
					<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
						<svg width="7.5" height="13.5">
							<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round"
								stroke-linejoin="round" stroke-width="1.5" />
						</svg>
					</a>
				</li>
			</ul>
		</nav>
	</div>
</ng-container>
<!-- paginator  -->